import AnimationIcon from '@mui/icons-material/Animation';
import FileUploadIcon from '@mui/icons-material/UploadFile';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import {
  AUDIENCE_BLENDER,
  AUDIENCE_BLENDER_SUB_TEXT,
  AUDIENCE_DESIGNER,
  AUDIENCE_DESIGNER_SUB_TEXT,
  AUDIENCE_FILE,
  AUDIENCE_FILE_SUB_TEXT,
} from '../../../content/index';
import {
  AUDIENCE_LAL_MODAL_TYPE,
  ENUM_SYSTEM_USED,
  Routes,
} from '../../../constants/index';
import { AudienceTypeSelector } from '../../../components/AudienceTypeSelector/index.jsx';
import { useAppSelector } from 'redux/hooks';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useHistory } from 'react-router';

export const AudienceSelector = () => {
  const history = useHistory();
  const lalModelType = useAppSelector(
    state => state.audienceReducer?.currentAudience?.lalModelType || ''
  );
  const { uiCombinedAudienceFeatureVisible = false } = useFlags();

  const handleNaviageToCreateAudience = (type: string) => {
    history.push({
      pathname: Routes.AUDIENCE_STUDIO_EDITOR,
      state: {
        audienceType: type,
      },
    });
  };

  const audienceOptions = [
    {
      id: ENUM_SYSTEM_USED.STANDARD_AUDIENCE,
      title: AUDIENCE_DESIGNER,
      description: AUDIENCE_DESIGNER_SUB_TEXT,
      icon: <ReceiptLongIcon />,
      onClick: handleNaviageToCreateAudience,
    },
    ...(uiCombinedAudienceFeatureVisible &&
    lalModelType === AUDIENCE_LAL_MODAL_TYPE.ATTAIN
      ? [
          {
            id: ENUM_SYSTEM_USED.COMBINED_AUDIENCE,
            title: AUDIENCE_BLENDER,
            description: AUDIENCE_BLENDER_SUB_TEXT,
            icon: <AnimationIcon />,
            onClick: handleNaviageToCreateAudience,
          },
        ]
      : []),
    {
      id: ENUM_SYSTEM_USED.CUSTOM_AUDIENCE,
      title: AUDIENCE_FILE,
      description: AUDIENCE_FILE_SUB_TEXT,
      icon: <FileUploadIcon />,
      onClick: handleNaviageToCreateAudience,
    },
  ];

  return <AudienceTypeSelector options={audienceOptions} />;
};
